import {
  LayoutGrid,
  Map,
  CalendarDays,
  Images,
  FileText,
  Users,
  Sparkles,
  Share2,
  Navigation,
  DollarSign,
  Link2,
  ShoppingBag,
  MapPin,
  type LucideIcon,
} from 'lucide-react'

export interface NavItem {
  to: string
  label: string
  Icon: LucideIcon
}

/** Per-trip navigation (UX_UI_CONCEPT.md §5). `:id` is the trip id. */
export function tripNavItems(tripId: string): NavItem[] {
  const base = `/trips/${tripId}`
  return [
    { to: base, label: 'Overview', Icon: LayoutGrid },
    { to: `${base}/places`, label: 'Places', Icon: MapPin },
    { to: `${base}/timeline`, label: 'Timeline', Icon: CalendarDays },
    { to: `${base}/map`, label: 'Map', Icon: Map },
    { to: `${base}/media`, label: 'Media', Icon: Images },
    { to: `${base}/documents`, label: 'Documents', Icon: FileText },
    { to: `${base}/people`, label: 'People', Icon: Users },
    { to: `${base}/links`, label: 'Links', Icon: Link2 },
    { to: `${base}/marketplace`, label: 'Marketplace', Icon: ShoppingBag },
    { to: `${base}/ai`, label: 'AI Planner', Icon: Sparkles },
    { to: `${base}/budget`, label: 'Budget', Icon: DollarSign },
    { to: `${base}/export`, label: 'Export', Icon: Share2 },
    { to: `${base}/live`, label: 'Today', Icon: Navigation },
  ]
}

/** Tabs shown in the mobile bottom bar while inside a trip. */
export function tripTabItems(tripId: string): NavItem[] {
  const base = `/trips/${tripId}`
  return [
    { to: base, label: 'Overview', Icon: LayoutGrid },
    { to: `${base}/places`, label: 'Places', Icon: MapPin },
    { to: `${base}/timeline`, label: 'Plan', Icon: CalendarDays },
    { to: `${base}/map`, label: 'Map', Icon: Map },
    { to: `${base}/live`, label: 'Today', Icon: Navigation },
  ]
}
